import { type IExamineWagerUseCase, type IWagerService } from '../../../domain/entry.js';

/**
 * Use case for examining a wager.
 *
 * @param wagerService Wager service dependency
 * @returns Use case executor for examining wagers
 */
export function examineWagerUseCase(wagerService: IWagerService): IExamineWagerUseCase {
  return {
    execute: async ({ wagerId, product, drawNumber }): ReturnType<IExamineWagerUseCase['execute']> => {
      await wagerService.examineWagerAsync({ wagerId, product, drawNumber });
    },
  };
}
